module.exports = __webpack_public_path__ + "static/media/banner1.3ad9c0ba.png";